// extracted by mini-css-extract-plugin
export default {"panel":"WarningPanel_panel__xFO-J","button":"WarningPanel_button__ViVsB","red":"WarningPanel_red__ueJMZ","blue":"WarningPanel_blue__-7tfK","inTable":"WarningPanel_inTable__kRS43"};